import Vue from 'vue';
import { NoticeBar } from 'vant';
import 'vant/lib/index.css';
import '@assets/scss/officialTopupNew/font/icon.js';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}

import { initBiPoint } from '../../resource/plugins/biPoint/index';

import App from '../../officialTopupNewApp.vue';
import router from '../rooters/officialTopupNew';
import store from '../stores/officialTopupNew';
import commonComponents from '@components/officialTopupNew/common/commonComponents';
import clickThrottling from '../../resource/plugins/clickThrottling';
import 'swiper/css/swiper.css';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import '@plugins/replaceAllPolyfills';
import globalConfig from '@utiles/officialStore/globalConfig';
import bridge from '@utiles/bridge';

// ！！！注意：重定向逻辑要在initBiPoint之前，否则会导致【会话开始】打点打在旧页面.
// 重定向逻辑 start
const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

// 2025.7.8 ROV跳转ROG V3第三方支付页
if ([371].includes(+gameId)) {
  const currentUrl = new URL(window.location);
  currentUrl.searchParams.set('gameId', 426);
  if (bridge.runInsdk()) {
    bridge.callSdkMethod('openWebView', {
      url: currentUrl.href,
      loginDir: 0,
      appendParams: 1,
      pageOrientation: 1
    });
  } else {
    window.location.href = currentUrl.href;
  }
}

handleStoreDefaultCid();
if (![371].includes(+gameId)) {
  initBiPoint({ dataLayerName: 'webstorev35DataLayer' });
}

Vue.use(NoticeBar);

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(300);

Vue.config.productionTip = true;
Vue.use(commonComponents);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialTopupNew');
